import { createDraftSafeSelector, createSlice} from '@reduxjs/toolkit'
import { AppState } from '../store/app-state'

export const dffSlice = createSlice({
  name: 'dff',
  initialState: {
    mount: null,
    user: null,
    baseUrl: null,
  },
  reducers: {
    selectMount: (state, { payload }) => {
      state.mount = payload
    },
    loadUser: (state, { payload }) => {
      state.user = payload.user
      state.user.extra = payload.extra
    },
    setBaseUrl: (state, { payload }) => {
      state.baseUrl = payload
    },
    resetUser: (state) => {
      return {
        ...state,
        user: null,
      };
    },
  },
})

export const { selectMount, loadUser, setBaseUrl } = dffSlice.actions

export const dffState = (state: AppState) => state.dff;
export const selectBaseUrl = createDraftSafeSelector(
  dffState,
  (state) => state.baseUrl,
);
export const mountSelector = createDraftSafeSelector(
  dffState,
  (state) => state.mount,
);

export default dffSlice.reducer
